import { LoadingScreen } from '@/components/common/LoadingScreen';
import Login from '@/pages/Login';
import { useAuth } from '@/hooks/useAuth';
import { useAuthStore } from '@/store/authStore';
import { resolvePostLoginRoute } from '@/utils/post-login-route';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const LoginRoute: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const { isUserReady, user } = useAuth();

  if (isAuthenticated) {
    // Wait until the roles are known before picking the destination, so a
    // future_owner is not sent to /inicio for a moment before hydrating.
    // `isLoadingUser` alone is not enough: it starts out false, with the profile
    // still on its way.
    if (!isUserReady) {
      return <LoadingScreen />;
    }
    // Same precedence as the post-login redirect, from the one place that owns it.
    return <Navigate to={resolvePostLoginRoute(user?.roles)} replace />;
  }

  return <Login />;
};
